import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const Sun = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 ".concat(size, " ").concat(size),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M9 12.375C7.13604 12.375 5.625 10.864 5.625 9C5.625 7.13604 7.13604 5.625 9 5.625C10.864 5.625 12.375 7.13604 12.375 9C12.375 10.864 10.864 12.375 9 12.375ZM9 13.5C11.4853 13.5 13.5 11.4853 13.5 9C13.5 6.51472 11.4853 4.5 9 4.5C6.51472 4.5 4.5 6.51472 4.5 9C4.5 11.4853 6.51472 13.5 9 13.5Z",
    fill: color
  }), __jsx("path", {
    d: "M9 0C9.31066 0 9.5625 0.25184 9.5625 0.5625V2.8125C9.5625 3.12316 9.31066 3.375 9 3.375C8.68934 3.375 8.4375 3.12316 8.4375 2.8125V0.5625C8.4375 0.25184 8.68934 0 9 0Z",
    fill: color
  }), __jsx("path", {
    d: "M9 14.625C9.31066 14.625 9.5625 14.8768 9.5625 15.1875V17.4375C9.5625 17.7482 9.31066 18 9 18C8.68934 18 8.4375 17.7482 8.4375 17.4375V15.1875C8.4375 14.8768 8.68934 14.625 9 14.625Z",
    fill: color
  }), __jsx("path", {
    d: "M18 9C18 9.31066 17.7482 9.5625 17.4375 9.5625H15.1875C14.8768 9.5625 14.625 9.31066 14.625 9C14.625 8.68934 14.8768 8.4375 15.1875 8.4375H17.4375C17.7482 8.4375 18 8.68934 18 9Z",
    fill: color
  }), __jsx("path", {
    d: "M3.375 9C3.375 9.31066 3.12316 9.5625 2.8125 9.5625H0.5625C0.25184 9.5625 -1.35794e-08 9.31066 0 9C1.35794e-08 8.68934 0.25184 8.4375 0.5625 8.4375H2.8125C3.12316 8.4375 3.375 8.68934 3.375 9Z",
    fill: color
  }), __jsx("path", {
    d: "M15.364 2.63607C15.5836 2.85574 15.5836 3.2119 15.364 3.43157L13.773 5.02256C13.5533 5.24223 13.1971 5.24223 12.9775 5.02256C12.7578 4.80289 12.7578 4.44673 12.9775 4.22707L14.5685 2.63607C14.7881 2.4164 15.1443 2.4164 15.364 2.63607Z",
    fill: color
  }), __jsx("path", {
    d: "M5.02252 12.9775C5.24219 13.1972 5.24219 13.5533 5.02252 13.773L3.43153 15.364C3.21186 15.5837 2.85571 15.5837 2.63604 15.364C2.41637 15.1443 2.41637 14.7882 2.63604 14.5685L4.22703 12.9775C4.4467 12.7578 4.80285 12.7578 5.02252 12.9775Z",
    fill: color
  }), __jsx("path", {
    d: "M15.364 15.364C15.1443 15.5837 14.7881 15.5837 14.5685 15.364L12.9775 13.773C12.7578 13.5533 12.7578 13.1972 12.9775 12.9775C13.1971 12.7579 13.5533 12.7579 13.773 12.9775L15.364 14.5685C15.5836 14.7882 15.5836 15.1443 15.364 15.364Z",
    fill: color
  }), __jsx("path", {
    d: "M5.02252 5.02257C4.80285 5.24224 4.4467 5.24224 4.22703 5.02257L2.63604 3.43158C2.41637 3.21191 2.41637 2.85576 2.63604 2.63609C2.85571 2.41642 3.21186 2.41642 3.43153 2.63609L5.02252 4.22708C5.24219 4.44675 5.24219 4.8029 5.02252 5.02257Z",
    fill: color
  }));
};
export default Sun;